// extracted by mini-css-extract-plugin
export default {"footer":"component-footer_footer__SmmIR","nav":"component-footer_nav__ou0jy","links":"component-footer_links__OMISm","link":"component-footer_link__N0Kwy"};